module.exports = __webpack_public_path__ + "static/media/Twodash_green.4989c5f4.svg";